import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CasoUsoDto } from '@models/seguridad/casosUso/casoUsoDto.model';
import { PermisoDto } from '@models/seguridad/permisos/permisoDto.model';
import { RolDto } from '@models/seguridad/roles/rolDto.model';
import { RolesService } from '@services/seguridad/roles/roles.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { DialogViewRolComponent } from './dialog-view-rol/dialog-view-rol.component';

@Component({
  selector: 'app-ver-rol',
  templateUrl: './ver-rol.component.html',
  styleUrls: ['./ver-rol.component.css']
})
export class VerRolComponent implements OnInit {

  formBuilder = new FormBuilder;
  form: any;
  permisoDto!: PermisoDto;
  casosUso!: CasoUsoDto[]
  roles!: RolDto[]
  casoUsoDto!: CasoUsoDto
  get f() { return this.form.controls; }

  constructor(
    public dialogRef: MatDialogRef<DialogViewRolComponent>,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private rolesService: RolesService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.form = this.formBuilder.group({
      Descripcion: ["", Validators.compose([Validators.required,])]
    })
  }

  ngOnInit(): void {
    this.getById(this.data.id)
    this.form.disable()
  }

  getById(id: number) {
    this.spinner.show("spBusquedaRoles")
    this.rolesService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaRoles")
          this.seteaForm(data)
        },
        error => {
          this.spinner.hide("spBusquedaRoles")
          this.snackBar.showError(error, "Error");
        }
      )
  }



  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  seteaForm(rolDto: RolDto) {
    this.form.controls["Descripcion"].setValue(rolDto.descripcion)
    this.form.disable()
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
